module.exports = __webpack_public_path__ + "static/img/9.99700ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/9.png
// module id = lP2k
// module chunks = 0